// Currency formatting utilities

export const formatCurrency = (
  amount: number,
  currency: string = 'NZD',
  locale: string = 'en-NZ'
): string => {
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(amount);
  } catch (error) {
    // Fallback for unsupported currencies or locales
    return `${currency} ${amount.toFixed(2)}`;
  }
};

export const parseCurrency = (value: string): number => {
  // Remove currency symbols and spaces, then parse as float
  const cleaned = value.replace(/[^\d.-]/g, '');
  const parsed = parseFloat(cleaned);
  return isNaN(parsed) ? 0 : parsed;
};

export const formatCompactCurrency = (
  amount: number,
  currency: string = 'NZD'
): string => {
  if (amount >= 1000000) {
    return `${currency} ${(amount / 1000000).toFixed(1)}M`;
  } else if (amount >= 1000) {
    return `${currency} ${(amount / 1000).toFixed(1)}K`;
  }
  return formatCurrency(amount, currency);
};

// Supported currencies
export const SUPPORTED_CURRENCIES = [
  { code: 'NZD', name: 'New Zealand Dollar', symbol: '$' },
  { code: 'AUD', name: 'Australian Dollar', symbol: '$' },
  { code: 'USD', name: 'US Dollar', symbol: '$' },
  { code: 'EUR', name: 'Euro', symbol: '€' },
  { code: 'GBP', name: 'British Pound', symbol: '£' },
] as const;

export type CurrencyCode = typeof SUPPORTED_CURRENCIES[number]['code'];
